var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_4562)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_78_4562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15.3287C12.4897 15.3287 15.3288 12.4896 15.3288 8.99991C15.3288 5.51023 12.4897 2.67114 9 2.67114C5.51032 2.67114 2.67123 5.51023 2.67123 8.99991C2.67123 12.4896 5.51032 15.3287 9 15.3287ZM4.12808 9.70311H6.20307C6.2678 11.1576 6.53203 12.4839 6.94966 13.4744C5.46015 12.7891 4.36924 11.3816 4.12808 9.70311ZM9 4.07754C9.06347 4.07754 9.24236 4.16814 9.4651 4.51109C9.96373 5.27874 10.3084 6.71684 10.3885 8.29671H7.61151C7.6916 6.71681 8.03631 5.27874 8.53491 4.51106C8.75768 4.16814 8.93654 4.07754 9 4.07754ZM10.3885 9.70311C10.3084 11.283 9.9637 12.7211 9.4651 13.4888C9.24236 13.8317 9.06347 13.9223 9 13.9223C8.93654 13.9223 8.75765 13.8317 8.53491 13.4887C8.03627 12.7211 7.6916 11.283 7.61151 9.70311H10.3885ZM11.0504 13.4744C11.468 12.4839 11.7322 11.1575 11.797 9.70311H13.872C13.6308 11.3816 12.5399 12.7891 11.0504 13.4744ZM13.8719 8.29671H11.7969C11.7322 6.84226 11.468 5.51592 11.0503 4.52544C12.5399 5.21067 13.6308 6.61825 13.8719 8.29671ZM6.94966 4.52544C6.53206 5.51596 6.2678 6.84229 6.20307 8.29671H4.12808C4.36924 6.61825 5.46015 5.21067 6.94966 4.52544Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3234 2.67658C12.5882 -0.0586468 8.40652 -0.776646 4.9179 0.889895C4.56746 1.05729 4.41908 1.4771 4.58648 1.8275C4.75391 2.17794 5.17375 2.32635 5.52412 2.15888C8.47596 0.748728 12.0144 1.35647 14.3289 3.67104C16.6435 5.98561 17.2512 9.52399 15.8411 12.4759C15.6737 12.8263 15.822 13.2461 16.1725 13.4135C16.5223 13.5806 16.9424 13.4331 17.1101 13.0821C18.7767 9.59346 18.0586 5.4118 15.3234 2.67658Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4759 15.841C9.52399 17.2511 5.98557 16.6434 3.67107 14.3289C1.3565 12.0143 0.748835 8.47592 2.15895 5.52405C2.32635 5.17361 2.17798 4.75384 1.82754 4.58644C1.47707 4.41901 1.05733 4.56738 0.889896 4.91782C-0.776644 8.40648 -0.0586452 12.5881 2.67654 15.3233C4.42884 17.0756 6.77449 17.9999 9.15147 17.9999C10.4849 17.9999 11.8284 17.7089 13.0821 17.11C13.4325 16.9426 13.5809 16.5228 13.4135 16.1724C13.2461 15.822 12.8263 15.6736 12.4759 15.841Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4696 14.4696C14.195 14.7443 14.195 15.1895 14.4696 15.4641C14.7442 15.7387 15.1895 15.7387 15.4641 15.4641C15.7387 15.1894 15.7387 14.7442 15.4641 14.4696C15.1895 14.195 14.7442 14.195 14.4696 14.4696Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53043 3.53051C3.80506 3.25588 3.80506 2.81065 3.53043 2.53605C3.25579 2.26142 2.81056 2.26142 2.53597 2.53605C2.26137 2.81065 2.26137 3.25592 2.53597 3.53051C2.81056 3.80511 3.25579 3.80511 3.53043 3.53051Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_4562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_78_4562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9fb09b275fe7024f69b52000730eb99c.svg";
export { ForwardRef as ReactComponent };